import React from 'react';

const StatsSection: React.FC = () => {
  const stats = [
    { label: 'Designs', value: '8' },
    { label: 'Elevations', value: '24' },
    { label: 'Possibilities', value: 'Endless' },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-5xl md:text-6xl font-bold text-primary mb-2">{stat.value}</div>
              <div className="text-xl text-gray-600 uppercase tracking-wider">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection; 